import { Badge } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { changeChat, createNewChatAsync } from "../../../../../ReduxToolkit/Reducers/Messenger/Chat";
import SvgIcon from "../../../../CommonComponents/SvgIcon";
import { dynamicImage, Image } from "../../../../../Utils";
import { setMobileMenu } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { useState } from "react";

const PrivateChat = () => {
  const dispatch = useAppDispatch();
  const { chatMembers, currentUser, chats, selectedUser} = useAppSelector((state) => state.chat);
  const [pinedMenu, setPinedMenu] = useState(Array(13).fill(false));
  var activeChat = 0;
  if (selectedUser != null) activeChat = selectedUser.id;
  const changeChatClick = (selectUser: number) => {
    const currentUserId = currentUser?.id;
    const currentChat = chats.find((x: { users: number[] }) => currentUser?.id !== undefined && x.users.includes(currentUser?.id) && x.users.includes(selectUser));
    if (currentChat) dispatch(changeChat(selectUser));
    else dispatch(createNewChatAsync({ currentUserId, selectUser, chats }));
    dispatch(setMobileMenu());
  };
  
  const handlePined = (id: number) => setPinedMenu((prevState) => prevState.map((item, index) => (index === id ? !item : item)));
  
  return (
    <ul className="chat-main custom-scroll">
      {chatMembers.slice(0, 8)
        .filter((x) => x.id !== currentUser?.id)
        .map((chatList, i) => (
          <li className={`${activeChat === chatList.id ? "active" : ""} ${pinedMenu[i] ? "pined" : ""}`} key={i} onClick={() => changeChatClick(chatList.id)}>
            <div className="chat-box">
              <div className={`profile ${chatList.onlineStatus}`}>{chatList.thumb ? <Image className="bg-img img-fluid" src={dynamicImage(chatList.thumb)} alt="Avatar" /> : <span>{chatList.name.split(" ").map((name) => name[0])}</span>}</div>
              <div className="details">
                <h4>{chatList.name}</h4>
                <h5 className={`${chatList.typing || chatList.status === "seen" || chatList.status === "image" ? "font-primary" : ""} ${chatList.onlineStatus === "busy" ? "font-danger" : ""} `}>
                  {chatList.status && <SvgIcon className="fill-primary" iconId={`${chatList.status === "seen" ? "right-2" : chatList.status === "image" ? "gallery" : "right"}`} />}
                  {chatList.mesg}
                </h5>
              </div>
              <div className="date-status">
                <i className="ti-pin2" onClick={() => handlePined(i)}></i>
                <h6>{chatList.lastSeenDate}</h6>
                {chatList.status === "image" && (<Badge color="primary" className="sm">2</Badge>)}
              </div>
            </div>
          </li>
        ))}
    </ul>
  );
};

export default PrivateChat;
